/* This is free and unencumbered software released into the public domain. */
export * from '@hqoss/monads';
